const C = {
  name: "ExclamationMark",
  dimensions: { width: 40, height: 36 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4985)">
    <path d="M39.8712 34.0014L20.8682 0.968395C20.5082 0.347775 19.488 0.347775 19.138 0.968395L0.135021 34.0014C-0.045007 34.3117 -0.045007 34.6921 0.135021 35.0024C0.315049 35.3127 0.6451 35.5029 1.00516 35.5029H39.0111C39.3711 35.5029 39.7012 35.3127 39.8812 35.0024C40.0412 34.6921 40.0412 34.3017 39.8712 34.0014ZM3.15549 32.7402L19.9981 3.4709L37.2708 33.5009H3.58556C3.2055 33.4909 2.96546 33.0805 3.15549 32.7402Z" />
    <path d="M19.998 25.4829C18.348 25.4829 16.998 26.8343 16.998 28.4859C16.998 30.1376 18.348 31.4889 19.998 31.4889C21.648 31.4889 22.998 30.1376 22.998 28.4859C22.998 26.8343 21.648 25.4829 19.998 25.4829ZM19.998 29.4869C19.448 29.4869 18.998 29.0365 18.998 28.4859C18.998 27.9354 19.448 27.4849 19.998 27.4849C20.548 27.4849 20.998 27.9354 20.998 28.4859C20.998 29.0365 20.548 29.4869 19.998 29.4869Z" />
    <path d="M16.998 15.4729V20.4779C16.998 22.1295 18.348 23.4809 19.998 23.4809C21.648 23.4809 22.998 22.1295 22.998 20.4779V15.4729C22.998 13.8212 21.648 12.4698 19.998 12.4698C18.348 12.4698 16.998 13.8212 16.998 15.4729ZM20.998 15.4729V20.4779C20.998 21.0284 20.548 21.4789 19.998 21.4789C19.448 21.4789 18.998 21.0284 18.998 20.4779V15.4729C18.998 14.9223 19.448 14.4719 19.998 14.4719C20.548 14.4719 20.998 14.9223 20.998 15.4729Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_4985">
    <rect width="40" height="35" fill="currentColor" transform="translate(0 0.50293)"/>
    </clipPath>
    </defs>
    </svg>

  `
};
export {
  C as ExclamationMark
};
